import { render, staticRenderFns } from "./CaseManagementNotes.vue?vue&type=template&id=713a5bc0&scoped=true&"
import script from "./CaseManagementNotes.vue?vue&type=script&lang=js&"
export * from "./CaseManagementNotes.vue?vue&type=script&lang=js&"
import style0 from "./CaseManagementNotes.vue?vue&type=style&index=0&id=713a5bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a5bc0",
  null
  
)

export default component.exports